export default __webpack_public_path__ + "static/media/nav-icon-mobile.8913eddb.png";